export enum StatusEnum {
  NORMAL = "",
  LOADING = "loading",
  ERROR = "error",
}
